export const moveToNextPage = () => {
  window.location.href = window.theme.Routing.redirectToNextPage(
    window.FKL.collectionMetafields,
    window.FKL.collectionHandle.replace("-cpl-offer-page", "")
  );
};

export const moveToNextPageAsync = () => {
  moveToNextPage();
  return new Promise((resolve) => setTimeout(resolve, 5000));
};
